// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__3RsDv","footer":"ModalError_footer__9pAmh"};